import { Address, L1ChainId, TokenId, TokenSymbol } from '../../types'
import { useSupportChains } from '../../store/app/hooks'
import { useSpotCurrencies } from '../../store/market/hooks'
import { useMemo } from 'react'

export function useEthereumTokenInfo(
  l1ChainId: L1ChainId,
  tokenId: TokenId
):
  | {
      id: TokenId
      symbol: TokenSymbol
      address: Address
      decimals: number
      fastWithdraw: boolean
    }
  | undefined {
  const supportChains = useSupportChains()
  const spotCurrencies = useSpotCurrencies()
  return useMemo(() => {
    if (!l1ChainId || !tokenId) {
      return
    }
    const chain = supportChains.find(
      (chain) => chain.layerOneChainId === l1ChainId
    )
    if (!chain) {
      return
    }

    const currency = spotCurrencies.find(
      (currency) => currency.l2CurrencyId === tokenId
    )
    if (!currency) {
      return
    }

    const tokenChain = currency.chains[chain.layerTwoChainId]
    if (!tokenChain) {
      return
    }
    return {
      id: currency.l2CurrencyId,
      symbol: currency.l2Symbol,
      address: tokenChain.address,
      decimals: tokenChain.decimals,
      fastWithdraw: tokenChain.fastWithdraw,
    }
  }, [supportChains, spotCurrencies, l1ChainId, tokenId])
}
